import { Controller } from "@hotwired/stimulus"

// Submits its form as soon as one of its fields changes (the admin's in-place edits)
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
